require('./brokerCashChargeSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { FIRST_STEP } = require('constants/index');

const CLASS_NAME = 'broker-cash-charge-success';
const RETURN_TO_CORPORATES_OPERATIONS_LINK = '/myprofile/broker/corporatesOperations';
const GO_TO_MY_WALLET_URL = '/myprofile/global';

class BrokerCashChargeSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.buildHeader = this.buildHeader.bind(this);
        this.buildField = this.buildField.bind(this);
        this.buildLeftColumnDetails = this.buildLeftColumnDetails.bind(this);
        this.buildRightColumnDetails = this.buildRightColumnDetails.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
    }

    buildField(primaryText, secondaryText, description = <span>&nbsp;</span>, primaryTextInjectStrings = []) {
        return (
            <div className={`${CLASS_NAME}__details-field`}>
                <h5 className={`${CLASS_NAME}__details-primary-text`}>
                    <FormattedText
                        value={primaryText}
                        format="uppercase"
                        injectedStrings={primaryTextInjectStrings}
                    />
                </h5>
                <div className={`${CLASS_NAME}__details-secondary-text`}>
                    {secondaryText}
                </div>
                <div className={`${CLASS_NAME}__details-gray`}>
                    {description}
                </div>
            </div>
        );
    }

    buildFooter() {
        return (
            <div>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <span className={`${CLASS_NAME}__corporates-operations-button`}>
                        <OKLink
                            modifier="complementary"
                            to={RETURN_TO_CORPORATES_OPERATIONS_LINK}
                        >
                            <FormattedText
                                value="cashCharge-returnToCorporateOperations"
                            />
                        </OKLink>
                    </span>
                    <OKButton
                        modifier="secondary"
                        to={GO_TO_MY_WALLET_URL}
                    >
                        <FormattedText
                            value="cashCharge-goToMyWallet"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildHeader() {
        const { immBrokerCashCharge } = this.props;
        const orderNumber = immBrokerCashCharge.get('orderNumber');

        return (
            <div className="wizard-success-step__highlight">
                <i className="wizard-success-step__success-icon" />
                <div className="wizard-success-step__messages">
                    <OKBoxTitle
                        value={formatText('cashCharge-successTitle')}
                    />
                    <div className="wizard-success-step__success-sub-message">
                        <FormattedText
                            value="cashCharge-successSubtitle"
                            injectedStrings={[orderNumber]}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildLeftColumnDetails() {
        const { immBrokerCashCharge } = this.props;
        const immOperation = immBrokerCashCharge.get('operation');
        const immContract = immBrokerCashCharge.get('contract');

        const contractNumber = immContract.get('number');
        const owner = immBrokerCashCharge.get('owner');
        const value = immOperation.get('descriptionValue');
        const contract = immBrokerCashCharge.get('walletAccountType');

        const contractNumberText = (
            <FormattedText
                value="cashCharge-successContractNumber"
                injectedStrings={[contractNumber]}
            />
        );
        const contractOwnerText = (
            <FormattedText
                value="cashCharge-contractOwnerName"
                injectedStrings={[owner]}
            />
        );

        // @hardcoded
        const valueField = this.buildField('cashCharge-value', value, 'Bolsa: Madrid Prue');
        const contractField = this.buildField('cashCharge-contract', contract);

        return (
            <div className={`${CLASS_NAME}__details-section-left`}>
                {valueField}
                {contractField}
                <div className={`${CLASS_NAME}__details-gray`}>
                    <div className={`${CLASS_NAME}__details-field`}>
                        {contractNumberText}
                        <br />
                        {contractOwnerText}
                    </div>
                </div>
            </div>
        );
    }

    buildRightColumnDetails() {
        const { immBrokerCashCharge } = this.props;
        const immOperation = immBrokerCashCharge.get('operation');
        const endDate = immOperation.get('endDate');
        const titlesAmount = immBrokerCashCharge.getIn(['steps', FIRST_STEP, 'titlesAmount']);

        const dateField = this.buildField('cashCharge-date', endDate);
        const titlesAmountField = this.buildField('cashCharge-titles', titlesAmount);

        return (
            <div className={`${CLASS_NAME}__details-section-right`}>
                {titlesAmountField}
                {dateField}
            </div>
        );
    }

    render() {
        return (
            <ContentBox>
                <h3><FormattedText value="cashCharge-successEndOperation" /></h3>
                {this.buildHeader()}
                <h4 className={`${CLASS_NAME}__details-title`}>
                    <FormattedText value="cashCharge-successCashChargeInformation" />
                </h4>
                <div className={`row ${CLASS_NAME}__details-container`}>
                    <div className="col-xs-4">
                        {this.buildLeftColumnDetails()}
                    </div>
                    <div className="col-xs-8">
                        {this.buildRightColumnDetails()}
                    </div>
                </div>
                {this.buildFooter()}
            </ContentBox>
        );
    }
}

BrokerCashChargeSuccess.propTypes = {
    immBrokerCashCharge: PropTypes.object.isRequired
};

module.exports = BrokerCashChargeSuccess;
